//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            adminSelected: 'View All',
            managerSelected: 'View All',
            accountingSelected: 'View All',
            selectedUser: null,
            selectedPrereg: {},
            filterText: '',
            // {
            //     "first_name": "Myrtice",
            //     "last_name": "Rosengart",
            //     "email": "mrosengart0@bloglovin.com",
            //     "role": "Corporate Admin"
            // }
            users: [],
            roles: [],
            prereg: []

        };
    },

    computed: {
        countPreRegs: function countPreRegs() {
            return this.prereg.length ? true : false;
        },
        filteredUsers: function filteredUsers() {
            if (!this.filterText) return this.users;

            var filterText = this.filterText.toLowerCase();

            return this.users.filter(function (u) {
                return u.first_name.toLowerCase().indexOf(filterText) > -1 || u.last_name.toLowerCase().indexOf(filterText) > -1;
            });
        },
        filteredPrereg: function filteredPrereg() {
            if (!this.filterText) return this.prereg;

            var filterText = this.filterText.toLowerCase();

            return this.prereg.filter(function (u) {
                return u.first_name.toLowerCase().indexOf(filterText) > -1 || u.last_name.toLowerCase().indexOf(filterText) > -1;
            });
        }
    },
    methods: {
        togglePrereg: function togglePrereg(prereg) {
            // This is ready when the other small modal changes get merged
            this.selectedPrereg = prereg;
            Event.$emit('show-small-modal', null, null, 'cancel-invite');
        },
        hideModal: function hideModal() {
            Event.$emit('hide-small-modal');
        },
        cancelPrereg: function cancelPrereg() {
            var _this = this;

            var self = this;

            axios.post('/prototype/cancel-invite', { id: this.selectedPrereg.id }).then(function (response) {

                self.getUsersAndRoles();
                Event.$emit('hide-small-modal');
                _this.$snotify.success('The invite was canceled.');
            });
        },
        add: function add() {
            Event.$emit('add-new-user');
        },
        addApi: function addApi() {
            Event.$emit('add-new-api-user');
        },
        edit: function edit(userId) {
            Event.$emit('edit-user', userId);
        },
        getUsersAndRoles: function getUsersAndRoles() {

            var self = this;

            window.axios.get('/prototype/user-api/all').then(function (response) {
                self.users = response.data.users;
                self.roles = response.data.roles;
                self.prereg = response.data.prereg;
            });
        },
        unslugify: function unslugify(text) {

            if (!text) return 'No Role Assigned';

            var t = text.replace('-', ' ').split(' ').map(function (s) {
                return s.charAt(0).toUpperCase() + s.substring(1);
            }).join(' ');

            return t;
        },
        countHasRole: function countHasRole(roleName) {
            var count = 0;
            this.filteredUsers.forEach(function (u, index) {
                if (u.role && u.role.includes(roleName)) count++;
            });

            return count;
        },
        countUsersWithNoRoles: function countUsersWithNoRoles() {
            var count = 0;
            this.filteredUsers.forEach(function (u, index) {
                if (!u.role) count++;
            });

            return count;
        },
        countInactiveUsers: function countInactiveUsers() {
            var count = 0;

            this.filteredUsers.forEach(function (u, index) {
                if (u.active === 0) count++;
            });

            return count;
        }
    },
    created: function created() {
        Event.$on('refresh-users-and-roles', this.getUsersAndRoles);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('refresh-users-and-roles');
    },
    mounted: function mounted() {
        this.getUsersAndRoles();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/users/UsersList.vue
// module id = XPkm
// module chunks = 0 1